import React,{useEffect , useState, useContext} from "react";
import { useNavigate } from "react-router-dom";
import FetchUtil from "../../utils/FetchUtil";
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import CompanySubscriptionModal from "../../components/CompanySubscriptionModal";
import {thisBaseURL} from "../../utils/helper.js";
import UserContext from "../../contexts/UserContext";

let availableFoods = [];
let subscriberFoods = [];
let accessibleFoods = [];
let foodList = [];
let foodOptions = [];
let foodGroupList = [];
let foodGroupOptions = [];


const foodGroupStyles = {
  control: styles => ({ ...styles, backgroundColor: 'white', borderRadius: '10px', 
  lineHeight : '25px', minHeight : '30px', height : '35px', fontSize : '16px', verticalAlign: 'middle'}),
  option: (styles, state) => {
    return {
      ...styles,
      lineHeight : '25px', height : '35px', fontSize : '16px',
      fontWeight: state.isSelected ? "bold" : "normal",
    };
  },
  singleValue: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '35px', fontSize : '16px', marginTop : '4px',
    }),
    indicatorSeparator: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '30px', fontSize : '16px', marginTop : '0px',
    }),
    indicatorContainer: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '30px', fontSize : '16px', marginTop : '4px',
    }),
    indicatorsContainer: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '30px', fontSize : '16px', marginTop : '4px',
    }),
    container: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '35px', fontSize : '16px', maxWidth: '30vw', whiteSpace: 'nowrap',
    }),
    input: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '30px', fontSize : '16px',
    }),
    placeholder: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '30px', fontSize : '16px', marginTop : '0px',
    }),
}

  const foodStyles = {
  control: styles => ({ ...styles, backgroundColor: 'white', borderRadius: '10px', 
  lineHeight : '25px', minHeight : '30px', height : '35px', fontSize : '16px', verticalAlign: 'middle'}),
  option: (styles, state) => {
    return {
      ...styles,
      lineHeight : '25px', height : '35px', fontSize : '16px',
      fontWeight: state.isSelected ? "bold" : "normal",
    };
  },
  singleValue: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '35px', fontSize : '16px', marginTop : '4px',
    }),
    indicatorSeparator: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '30px', fontSize : '16px', marginTop : '0px',
    }),
    indicatorContainer: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '30px', fontSize : '16px', marginTop : '4px',
    }),
    indicatorsContainer: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '30px', fontSize : '16px', marginTop : '4px',
    }),
    container: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '35px', fontSize : '16px', maxWidth: '40vw',
    }),
    input: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '30px', fontSize : '16px',
    }),
    placeholder: (styles, state) => ({
      ...styles,
      lineHeight : '25px', height : '30px', fontSize : '16px', marginTop : '0px',
    }),
}
    
function Foods() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [error, setError] = useState(null);
	const [showSubMsg, setShowSubMsg] = useState(false);
	const [foods, setFoods] = useState([]);
	const [foodGroupLoaded, setFoodGroupLoaded] = useState(false);
	const userCtx = useContext(UserContext);
	let canRead = false;
	if(userCtx){
		canRead = userCtx.isSubscriptionValid;
	}
	
	useEffect(() => {
		fetchFoodGroups();
		fetchFoods();
	}, []);
	
	function setFoodGroupValues(foodGroupObj){
		let foodGroupOptionValue = {};
		foodGroupOptions =[];
		foodGroupOptions.push({label :"Showing all food groups", value :"all"});
		if(foodGroupObj && foodGroupObj.length > 0){
			foodGroupObj.map( (foodGroup, index) =>{
				foodGroupOptionValue.label = foodGroup.groupName;
				foodGroupOptionValue.value = foodGroup.sanitizedGroupName;
				foodGroupOptions.push(foodGroupOptionValue);
				foodGroupOptionValue = {};
			});
		}
		setFoodGroupLoaded(true);
	}
	
	function setFoodValues(foodObj){
		//setFoods([]);
		let foodOptionValue = {};
		let label = '';
		foodOptions =[];
		if(foodObj && foodObj.length > 0){
			foodObj.map( (food, index) =>{
				if(food.published && (food.statusCode === 1) ){
					label = food.foodName;
					availableFoods.push(food.foodId);
					if (food.requireSubscription && !canRead) {
						label = food.foodName + ' $';
				        subscriberFoods.push(food.foodId);
			      	} 
			      	if(canRead){
						accessibleFoods.push(food.foodId);
					}
					foodOptionValue.label = label;
					foodOptionValue.value = food.foodId;
					foodOptions.push(foodOptionValue);
					foodOptionValue = {};
				}
			});
		}
		setFoods(foodObj);
	}
	
	function fetchFoodGroups() {
	    const requestOptions = {
	      credentials: "same-origin",
	      method: "POST",
	      headers: { "Content-Type": "application/json" },
	      body: JSON.stringify({ source: "web"}),
	    };
	    try{
		   FetchUtil.fetchAPI("GetFoodGroups","/Service/StaticHelper/GetFoodGroups", requestOptions, getFoodGroupsSuccess, getFoodGroupsFail);
		} catch (error) {
		   setError(error.message);
		}
	}
  
  	function getFoodGroupsFail(redirect){
  	  setError(t("error.getFoodGroupFailed"));
  	}
  
  	function getFoodGroupsSuccess(responseData){
	  	var foodGroupsResponse;
	  	if (responseData) {
	    	foodGroupsResponse = responseData.getFoodGroupsResponse;
	     	if (foodGroupsResponse && foodGroupsResponse.errorCode === "0") {
				 foodGroupList = foodGroupsResponse.foodGroups;
				 setFoodGroupValues(foodGroupList);
	      	} else if (foodGroupsResponse){
		    	setError(t("error.error") + " " +foodGroupsResponse.errorMessage);
	      	}
	 	 }
	}
	
	function fetchFoods() {
	    const requestOptions = {
	      credentials: "same-origin",
	      method: "POST",
	      headers: { "Content-Type": "application/json" },
	      body: JSON.stringify({ source: "web"}),
	    };
	    try{
		   FetchUtil.fetchAPI("GetFoods","/Service/StaticHelper/GetFoods", requestOptions, getFoodsSuccess, getFoodsFail);
		} catch (error) {
		   setError(error.message);
		}
	}
  
  	function getFoodsFail(redirect){
  	  setError(t("error.getFoodFailed"));
  	}
  
  	function getFoodsSuccess(responseData){
	  	var foodsResponse;
	  	if (responseData) {
	    	foodsResponse = responseData.getFoodsResponse;
	     	if (foodsResponse && foodsResponse.errorCode === "0") {
				foodList = foodsResponse.foods;
	       		setFoodValues(foodsResponse.foods);
	      	} else if (foodsResponse){
		    	setError(t("error.error") + " " +foodsResponse.errorMessage);
	      	}
	 	 }
	}
	
	const handleFoodClick = (e, foodId)  =>{
		//console.log("handleFoodClick "+foodId);
		let foodName = "";
		let slug = "";
		if (!availableFoods.includes(foodId)) {
			console.log("Food not found "+foodId);
			e.preventDefault();
        } else {
			if (subscriberFoods.includes(foodId)  && !accessibleFoods.includes(foodId) ) {
				console.log("Food sub needed "+foodId);
            	e.preventDefault();
            	subscribePopupMsg(true);
          	} else {
				foods.map( (food, index) =>{
					//console.log("handleFoodClick in Map "+foodId);
					if(food.foodId === foodId){
						foodName = food.foodName;
						slug = food.slug;
						return;
					}
				});
				//console.log("handleFoodClick after Map "+foodId +" and slug "+ slug);
            	navigate('/foods/' + slug);
          	}
        }
	}
	
	function subscribePopupMsg(display){
		if(display){
			document.getElementById("page").classList.add("no-pointer");
			setShowSubMsg(true);
		}else{
			document.getElementById("page").classList.remove("no-pointer");
			setShowSubMsg(false);
		}
	}
	const handleGroupChange = (selectedOption) => {
		let sanitizedName = selectedOption.value;
	   	let groupName = selectedOption.label;
	   	if(sanitizedName === "all"){
			setFoodValues(foodList);
		}else{
			let filteredFoodList = [];
			foodList.map( (food, foodindex) =>{
				let groups = food.foodGroups;
				groups.map( (foodGroup, grpindex) =>{
				  if(foodGroup.sanitizedGroupName === sanitizedName){
					  filteredFoodList.push(food);
					  return;
				  }
			    });
			});
			setFoodValues(filteredFoodList);
		}
	};
	const handleFoodChange = (selectedOption) => {
		let foodId = selectedOption.value;
	   	let foodName = selectedOption.label;
	   	let slug = "";
	   	if (subscriberFoods.includes(foodId)  && !accessibleFoods.includes(foodId) ) {
            	subscribePopupMsg(true);
        } else {
			foodList.map( (food, index) =>{
				if(food.foodId === foodId){
					slug = food.slug;
					return;
				}
			});
	    	navigate('/foods/' + slug);
       }
	};
  	return (
		<div id="page">
			 {(error) && (
		        <div id="inerrorMessage" className="alert.alert-danger">
		          {error}
		        </div>
		      )}
		     <div className="page-filterdd">
		        <div className="row">
		           <div className="col-5" style={{paddingLeft: "0px"}}>
			     <Select
			         name="foodgroup"
				     onChange={handleGroupChange}
		        	 options={foodGroupOptions}
		        	 defaultValue={{label :"Showing all food groups", value :"all"}}
		        	 isSearchable={true}
		        	 className="myselect"
		        	 styles={foodGroupStyles}
		         />
		         </div>
		         <div className="col-7">
		         <Select
			         name="food"
				     onChange={handleFoodChange}
		        	 options={foodOptions}
		        	 placeholder="Search for a food"
		        	 isSearchable={true}
		        	 className="myselect"
		        	 styles={foodStyles}
		         />
		         </div>
		      </div>
		    </div>
		    <br />
			<div className="collage">
			{foods && foods.length > 0 && (
				 foods.map((food, foodIndex) => (
					(food && food.published && (food.statusCode === 1)) && (
						<a data-groups="" 
						   className={(food.requireSubscription)?"requires-subscription effect-1 effect-duration-1 photo-block": "free effect-1 effect-duration-1 photo-block"} 
						   onClick={(e) =>handleFoodClick(e, food.foodId)}
						   >
						<img data-width="200" data-height="200" src={thisBaseURL +food.photoFilePath} alt={food.photoFileName} />
						  <div className="image_text">
						    <small className={(food.foodName.length > 20)?"small":"large"}>{food.foodName}</small>
						    {(food.requireSubscription && !canRead)?<span className="label label-success">$</span>:""}
						  </div>
						</a>
			      	)
		       	 ))
		      	)}
			</div>
      		{showSubMsg && <CompanySubscriptionModal setShow={subscribePopupMsg} />}
        </div>
  );
}
export default Foods;
